var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#888B8D",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.041 12.896v-8.69H.298v8.69H3.04zM1.67 3.02c.956 0 1.552-.667 1.552-1.5C3.204.666 2.626.017 1.688.017.749.018.136.667.136 1.52c0 .834.595 1.501 1.516 1.501h.018zM4.56 12.896h2.743V8.043c0-.26.017-.519.09-.704.198-.52.65-1.057 1.407-1.057.993 0 1.39.797 1.39 1.965v4.649h2.743V7.913c0-2.668-1.353-3.91-3.158-3.91-1.48 0-2.13.87-2.491 1.463h.019v-1.26H4.559c.036.816 0 8.69 0 8.69z",
    transform: "translate(5.035 5.003)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/linked-in-icon.42a35f08.svg";
export { ForwardRef as ReactComponent };